import { useMemo } from 'react';
import { useGetAllFeatureFlagQuery } from '../features/featureFlag/featureFlagApi';
import { MANAGE_SERVICE_ACCOUNTS_FEATURE_FLAG } from '../constants';
import { FeatureFlagData } from '../types';

/**
 * Reads the `ManageServiceAccounts` feature flag from the feature-flags API.
 *
 * @param enabled - When `true` (default) the feature-flags query runs.
 * @returns An object with the enabled state and flag loading state.
 */
export const useManageServiceAccountsFlag = (
    enabled = true
): { isManageServiceAccountsEnabled: boolean; isFlagLoading: boolean } => {
    const { data: featureFlags, isLoading } = useGetAllFeatureFlagQuery({}, { skip: !enabled });
    const flag = useMemo(
        () =>
            featureFlags?.data?.find(
                (f: FeatureFlagData) => f.featureFlagName === MANAGE_SERVICE_ACCOUNTS_FEATURE_FLAG
            ),
        [featureFlags]
    );

    return { isManageServiceAccountsEnabled: Boolean(flag?.enabled), isFlagLoading: isLoading };
};
